export default __webpack_public_path__ + "static/media/03.cbc9ab8a.svg";